import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderApiService } from 'src/app/services/api/order-api.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-user-profile-order-refund-page',
  templateUrl: './user-profile-order-refund-page.component.html',
  styleUrls: ['./user-profile-order-refund-page.component.scss'],
})
export class UserProfileOrderRefundPageComponent implements OnInit {
  loading = false;

  /** 当前退款的订单 */
  order: any = null;

  /** 已提交退款详情（查看退款详情时使用） */
  detail: any = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private api: OrderApiService,
    private message: MessageService,
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const id = params['id'];
      if (id) {
        this.loadOrder(id, params['view'] === 'detail');
      }
    });
  }

  async loadOrder(id: any, viewDetail: boolean) {
    try {
      this.loading = true;
      const r = await this.api.getUserOrder(id);
      this.order = r.data;
      if (viewDetail) {
        await this.loadRefundDetail(id);
      }
    } catch (error) {
      this.message.error('网络错误');
    } finally {
      this.loading = false;
    }
  }

  /** 查看已提交的退款详情 */
  async loadRefundDetail(id: any) {
    try {
      const r = await this.api.findRefundLogs(id);
      if (r?.status === 0) {
        this.detail = r.data || {};
      } else {
        this.message.warn(r.data);
      }
    } catch (error) {
      this.message.error('网络错误');
    }
  }
}
